//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    codeNum: {
      type: Number,
      default: 4
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      code: '',
      index: -1,
      spanCode: {
        0: ' ',
        1: ' ',
        2: ' ',
        3: ' '
      },
      add: true
    }
  },
  watch: {
    spanCode: {
      handler (v) {
        let flag = true
        let code = ''
        for (let i = 0; i < this.codeNum; i++) {
          code += this.spanCode[i]
          if (this.spanCode[i] === ' ') {
            flag = false
          }
        }
        if (flag) {
          this.$emit('completeInput', code)
        }
      },
      deep: true
    }
  },
  methods: {
    inputCode (i) {
      this.index = i
      this.code = ''
      this.$refs.focusDefault.focus()
    },
    changeCode () {
      if (!this.add) {
        if (this.spanCode[this.index] === ' ') {
          this.index--
        } else {
          this.spanCode[this.index] = ' '
        }

        if (this.index < 0) {
          this.index = -1
          this.$refs.focusDefault.blur()
        }
      } else {
        this.spanCode[this.index] = this.code.slice(-1)
        this.index++
        if (this.index >= this.codeNum) {
          this.index = -1
          this.$refs.focusDefault.blur()
        }
      }
    },
    selectCode (e) {
      let k = e.keyCode || e.which
      if (k === 8) {
        this.add = false
      } else {
        this.add = true
      }
    },
    codeBlur () {
      this.index = -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/uiCode.vue